'use strict';
const angular = require('angular');

export class calendarWidgetComponent {

  constructor($uibModal, CalendarEventService, Auth, dialogs, IntegrationService) {
    'ngInject';

    this.$uibModal = $uibModal;
    this.CalendarEventService = CalendarEventService;
    this.IntegrationService = IntegrationService;
    this.Auth = Auth;
    this.dialogs = dialogs;

    this.eventSources =  [];
    var eventSource = {
      events: []
    };

    this.eventSources.push(eventSource);

    this.uiConfig = {
      calendar: {
        timezone: 'local',
        editable: true,
        defaultView: 'listWeek',
        header: {
          left: '',
          center: '',
          right: ''
        },
        eventRender: (event, el) => {
          // Recurring Events
          if (event.isRecurring) {
            if (!(event.start.isBefore(event.range.end) && event.start.isAfter(event.range.start)))
              return false;
          }
        },
        eventClick: (calendarEvent, jsEvent, view) => {

          if (this.public) {
            this.dialogs.notify("Event Details","Event details are only visible when logged in");
            return;
          }

          var that = this;

          var modalInstance = this.$uibModal.open({
            animation: true,
            component: 'calendarEventDetail',
            resolve: {
              calendarEvent: function () {
                return calendarEvent;
              },
              config: function () {
                return {
                  userHasPermission: !calendarEvent.isExtern && (
                    that.Auth.isAdminSync()
                    || (that.Auth.getCurrentUserSync()._id === calendarEvent.meta.creationUser)
                  )
                }
              }
            }
          });

          modalInstance.result.then(
            function (result) {

              if (result.action === 'removed') {
                that.$timeout(() => {
                  that.getData();
                }, 0);
              }

            },
            function () {
            }
          );

        }
      }
    };

  }

  $onInit() {
    let METHOD = "get";

    METHOD += (this.public) ? "PublicUpcoming" : "Upcoming";
    METHOD += (this.categories) ? "ByCategories": "";

    this.CalendarEventService[METHOD]({count: this.count || 25, categories: this.categories}, data => {
      data.forEach(evt => {

        var event = evt;

        event.orig = {
          start: event.start,
          end: event.end
        };

        if (event.isRecurring) {
          event.range = {start: event.start, end: event.recurrence.until};

          event.start = moment(event.start).format("HH:mm");

          if (event.end)
            event.end = moment(event.end).format("HH:mm");

          event.dow = event.recurrence.dayOfWeek;
          event.id = event._id;
        }

        this.eventSources[0].events.push(event);
      });
    }, err => {
      console.log('could not retrieve newest events');
    }) ;

    /* Master Events */
    if (this.master) {
      let masterCategories = this.master.split(',').map(cat => cat.trim());
      masterCategories.forEach(cat => {
        this.IntegrationService.getCalendarByType({type: cat}, data => {

          data.forEach(evt => {

            var event = evt;

            event.orig = {
              start: event.start,
              end: event.end
            };

            if (event.isRecurring) {
              event.range = {start: event.start, end: event.recurrence.until};

              event.start = moment(event.start).format("HH:mm");

              if (event.end)
                event.end = moment(event.end).format("HH:mm");

              event.dow = event.recurrence.dayOfWeek;
              event.id = event._id;
            }

            event.isExtern = true;
            this.eventSources[0].events.push(event);
          });

        }, err => {
          console.log('could not retrieve events from server');
        });
      })
    }

  }
}

export default angular.module('conduuApp.calendarWidget', [])
  .component('calendarWidget', {
    template: `<div id="fullCalendarMain" ui-calendar="$ctrl.uiConfig.calendar" class="span8 calendar" ng-model="$ctrl.eventSources"></div>`,
    bindings: {
     count: '@',
     public: '<',
     categories: '@',
     master: '@'
    },
    controller: calendarWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/sidebar/calendar-widget/calendar-widget.component.js